(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/competition-handler/client/create-competition-handler.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/competition-handler/client/create-competition-handler.js');
'use strict';

var _svs$competition$data, _svs, _svs$competition$data2, _svs2, _svs$competition$data3, _svs3, _svs$competition$data4, _svs4, _svs5;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$components$marke = svs.components.marketplaceCompetition.competitionHandler.common,
  createCompetitionModel = _svs$components$marke.createCompetitionModel,
  createCompetitionHandlerBase = _svs$components$marke.createCompetitionHandlerBase,
  createPlayerCompetitionHandlerBase = _svs$components$marke.createPlayerCompetitionHandlerBase,
  pipe = _svs$components$marke.functional.pipe;
const createJupiterInstance = svs.components.marketplaceCompetition.competitionHandler.client.createJupiterInstance;
const drawHandler = svs.components.sport.drawHandler.drawHandler;
const competitionsData = (_svs$competition$data = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.competition) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.competitions) === null || _svs === void 0 ? void 0 : _svs.competitions) !== null && _svs$competition$data !== void 0 ? _svs$competition$data : {};
const activeCompetitionIds = (_svs$competition$data2 = (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.competition) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 || (_svs2 = _svs2.competitions) === null || _svs2 === void 0 ? void 0 : _svs2.activeCompetitionIds) !== null && _svs$competition$data2 !== void 0 ? _svs$competition$data2 : [];
const playerCompetitions = (_svs$competition$data3 = (_svs3 = svs) === null || _svs3 === void 0 || (_svs3 = _svs3.competition) === null || _svs3 === void 0 || (_svs3 = _svs3.data) === null || _svs3 === void 0 || (_svs3 = _svs3.playerDetail) === null || _svs3 === void 0 ? void 0 : _svs3.playerCompetitions) !== null && _svs$competition$data3 !== void 0 ? _svs$competition$data3 : {};
const playerCompetitionDraws = (_svs$competition$data4 = (_svs4 = svs) === null || _svs4 === void 0 || (_svs4 = _svs4.competition) === null || _svs4 === void 0 || (_svs4 = _svs4.data) === null || _svs4 === void 0 || (_svs4 = _svs4.playerDetail) === null || _svs4 === void 0 ? void 0 : _svs4.playerCompetitionDraws) !== null && _svs$competition$data4 !== void 0 ? _svs$competition$data4 : {};
const playerCompetitionFetchStatus = (_svs5 = svs) === null || _svs5 === void 0 || (_svs5 = _svs5.competition) === null || _svs5 === void 0 || (_svs5 = _svs5.data) === null || _svs5 === void 0 || (_svs5 = _svs5.playerDetail) === null || _svs5 === void 0 ? void 0 : _svs5.status;
const _svs$components$lbUti = svs.components.lbUtils.onEvents,
  onEvent = _svs$components$lbUti.onEvent,
  eventNames = _svs$components$lbUti.eventNames;
const jupiter = createJupiterInstance();
const createCompetitionHandler = function () {
  let privateInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  privateInterface.setPlayerCompetitionDetails({
    playerCompetitions,
    playerCompetitionDraws,
    status: playerCompetitionFetchStatus
  });
  onEvent(eventNames.PAYMENT_SUCCESS, _ref => {
    var _payable$isCompetitio;
    let payable = _ref.detail.payable;
    if ((_payable$isCompetitio = payable.isCompetition) !== null && _payable$isCompetitio !== void 0 && _payable$isCompetitio.call(payable)) {
      const bet = payable.getCompetitionBet();
      const competitionId = payable.competitionId[0];
      privateInterface.setPlayerCompetitionDraw({
        drawNumber: bet.drawNumber,
        competitionId
      });
    }
  });
  onEvent(eventNames.COMPETITION_SIGN_UP, _ref2 => {
    let competitionId = _ref2.detail.competitionId;
    privateInterface.setPlayerCompetition({
      competitionId
    });
  });
  onEvent(eventNames.PAYMENT_CANCEL, _ref3 => {
    let wager = _ref3.detail.wager;
    if (wager.competitionId) {
      const competitionId = wager.competitionId;
      privateInterface.deletePlayerCompetitionDraw({
        drawNumber: wager.drawNumber,
        competitionId
      });
    }
  });
  return function () {
    let publicInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    for (const _ref4 of Object.entries(competitionsData)) {
      var _ref5 = _slicedToArray(_ref4, 2);
      const competitionData = _ref5[1];
      const _competitionData$mode = competitionData.model.details,
        productId = _competitionData$mode.productId,
        drawNumber = _competitionData$mode.currentDrawNumber;
      const draw = drawHandler().get(productId, drawNumber);
      const competition = createCompetitionModel(competitionData, draw);
      privateInterface.competitionCache.setModel(competition);
    }
    privateInterface.setCmsCompetitionIds(activeCompetitionIds);


    publicInterface.getPlayerCompetitionDetails = () => JSON.parse(JSON.stringify(privateInterface.getPlayerCompetitionDetails()));
    return publicInterface;
  };
};

const privateInterface = {
  jupiter
};
const fns = [createCompetitionHandlerBase, createPlayerCompetitionHandlerBase, createCompetitionHandler].map(fn => fn(privateInterface));
const competitionHandlerCreator = pipe(...fns);
setGlobal('svs.components.marketplaceCompetition.competitionHandler.client.createCompetitionHandler', competitionHandlerCreator);

 })(window);